import Consent from "@/types/Consent.interface"
import ConsentSent from "@/types/ConsentSent.interface"

interface State {
    consent: Consent
    optedOut: number[]
}

const defaults = () => {
    return {
        consent: null,
        optedOut: []
    }
}
export default {
    state: defaults(),
    mutations: {
        optedOutSet (state: State, optedOut: number[]): void {
            state.optedOut = optedOut
        },
        optedOutAdd (state: State, msisdn: number): void {
            //  Check if the msisdn is in the 'removed' list
            const i = state.optedOut.indexOf(msisdn)

            //  If the msisdn does NOT exist, add it
            if (i === -1) state.optedOut.push(msisdn)
        },
        optedOutRemove (state: State, msisdn: number): void {
            //  Check if the msisdn is in the 'removed' list
            const i = state.optedOut.indexOf(msisdn)

            //  If the msisdn exists, remove it
            if (i > -1) state.optedOut.splice(i, 1)
        },
        consentReset (state: State): void {
            Object.assign(state, defaults())
        },
        consentSet (state: State, consent: Consent): void {
            state.consent = consent
        },
    },
    actions: {
        consentGet ({ commit, getters }): Promise<Consent> {
            //  Assemble the API endpoint
            const url = `${getters.api}/consent`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our consent
                commit('consentSet', response.data)

                //  Return the consent
                return response.data
            }).catch(() => null)
        },
        consentPut ({ commit, getters }, consent: Consent): Promise<Consent> {
            //  Assemble the API endpoint
            const url = `${getters.api}/consent`

            //  Send the request
            return window.axios.put(url, consent).then(response => {
                //  Set our consent
                commit('consentSet', response.data)

                //  Return the consent
                return response.data
            }).catch(() => null)
        },
        optedOutGet ({ commit, getters }): Promise<void> {
            //  Assemble the API endpoint
            const url = `${getters.api}/consent-opted-out`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Commit our opted out array
                commit('optedOutSet', response.data)
            }).catch(() => null)
        },
        consentSentGet ({ getters }, msisdn: number): Promise<ConsentSent> {
            //  Assemble the API endpoint
            const url = `${getters.api}/consent-sent?msisdn=${msisdn}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Check if an empty object was returned
                const isEmpty = window._.isEmpty(response.data)

                //  If the response is an empty object, return null
                if (isEmpty) return null
                
                //  Else, return the object
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        consent (state: State): Consent {
            return state.consent
        },
        optedOut (state: State): number[] {
            return state.optedOut
        }
    }
}
